import flatten from 'lodash/flatten';
import { systemThemes } from '@/config/widgetTheme';
import { createSystemThemeVariants } from '@/services/widgetTheme';
export const SYSTEM_THEMES = flatten(systemThemes.map(createSystemThemeVariants));
export const SYSTEM_THEME = SYSTEM_THEMES[0];